// extracted by mini-css-extract-plugin
export default {"container":"style_container__wb8U4","number":"style_number__1L6Fk"};